export default __webpack_public_path__ + "static/media/nesto-online-logo.b2e01dd6.svg";